<template>
	<div class="containerall">
		<div class="fot">
			<div class="fot1">
				<div class="fot1-text">
					<div class="fot1-text1">
						<span>地址：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第3栋6楼  电话：</span>
						<span @click="callphone('19857413451')" class="fot1-text1-phone">15899889999</span>
					</div>
				</div>
			</div>
			<div class="fot2">
				
				<span class="fot2-text">版权所有◎2023 深圳市乐园互联网科技有限公司 </span>
				<!-- <span class="fot2-text">网站建设：</span> -->
				
				<a href="https://beian.miit.gov.cn/#/Integrated/index"><span class="fot2-text">粤ICP备2020101379号-1</span></a>
				
			<!-- 	<a href="http://hangzhou.300.cn"><span class="fot2-text">杭州</span></a>
				<span class="fot2-text" @click="goseo">SEO</span></a>
				<span class="fot2-text" @click="gofotter">营业执照</span> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		methods:{
			callphone(phoneNumber){
				console.log(phoneNumber);
				window.location.href = "tel://" + phoneNumber;
			},
			gofotter(){
				this.$router.push('/license')
			},
			goseo(){
				this.$router.push('/seo')
			}
		}
	}
</script>

<style scoped>
	.containerall{
		padding-top: 20px;
	}
	.fot1{
		/* background-color: rgba(81, 84, 87, 1); */
		background: #000000;
		width: 100%;
		
	}
	.fot1-text{
		max-width: 1230px;
		padding-top: 20px;
		/* padding-bottom: 20px; */
		padding-left: 15px;
		padding-right: 15px;
		text-align: center;
		margin: auto;
	}
	.fot1-text1{
		text-align: center;
		font-size: 14px;
		line-height: 1.8;
		color: #D3D3D3;
		font-family: 微软雅黑;
	}
	.fot2{
		background: #000000;
		padding-top: 20px;
		padding-bottom: 20px;
		text-align: center;
		padding-left: 20px;
		padding-right:20px;
	}
	.fot2-text{
		margin-right: 10px;
		text-align: center;
		font-size: 14px;
		/* color: #ffffff; */
		color: #D3D3D3;
		font-family: 微软雅黑;
		cursor: pointer;
	}
	.fot1-text1-phone{
		cursor: pointer;
	}
</style>